import { defineMessages } from 'react-intl';

export const messages: {
	relatedSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teammatesAlsoAsk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	relatedSearch: {
		id: 'leap-query.title.related-search',
		defaultMessage: 'Related searches',
		description: 'Title for leap query section: related searches',
	},
	teammatesAlsoAsk: {
		id: 'leap-query.title.teammates-also-ask',
		defaultMessage: 'Your teammates also ask',
		description: 'Title for leap query section: your teammates also ask',
	},
});
